import styled from "styled-components";
import { motion } from "framer-motion";

type CarrouselType = {
    maxlenght: number;
}

export const SCarousel = styled(motion.div) <CarrouselType>`
    overflow: hidden;
    width:${props => (props.maxlenght * 136) < 1400 ?
        `calc(${props.maxlenght}*8.5rem)`
        : '100%'
    } ;

    @media screen and (max-width: 990px)  {
        width: 100%;
    }
    div{
        display:flex;
        width:calc((${props => props.maxlenght})*8.5rem);
        background-color: transparent;
    }
`

export const ItemsCarousel = styled(motion.article)`
    height: 10rem;
    width: 8.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    pointer-events: none;
    
 h3{
    font-size: 1.1rem;
    color: ${props => props.theme.colors.white};
    margin-top: 1rem;
}
`